import React from "react";
import ReservationSidebar from "../../Commun/ReservationSidebar";
import ReservationHeader from "../../Commun/ReservationHeader";

export const RoomDetails = () => {
  return (
    <>
      <div className="wrapper">
        <ReservationSidebar />
        <div className="main-panel">
          <ReservationHeader />
          <div className="container">
            <div className="page-inner"></div>
          </div>
        </div>
      </div>
    </>
  );
};
